import { h } from 'preact';
import { isFocusStudio } from 'utils/studioConfig';

import UniversalMovieHeaderEditor from 'components/editor/movies/movieHeader/movieHeaderUniversal';
import FocusMovieHeaderEditor from 'components/editor/movies/movieHeader/movieHeaderFocus';

export default (props) => {
	if (isFocusStudio()) return <FocusMovieHeaderEditor {...props} />;
	return <UniversalMovieHeaderEditor {...props} />;
};